import Gateway from '../model/gateway';

/**
 * Gateway service
 * @type {{init: (function()), getGatewaySvc: (function())}}
 */

export const GatewaySvc = {
  /**
   * Initialize gateway service
   */
  init() {
    this.gatewaySvc = new Gateway();
  },

  /**
   * Get gateway service
   * @returns {Gateway|GatewaySvc}
   */
  getGatewaySvc() {
    return this.gatewaySvc;
  },
};






// WEBPACK FOOTER //
// gateway.service.js